import React,{useState} from 'react'
import LoremIpsum from 'react-lorem-ipsum'
import friends from '../images/backgrounds/b1.png'
import checkmark from '../images/checkmark.png'
import {ethers} from 'ethers'
import{owners} from './recruit_helper';
import axios from 'axios'
const StatusTracker = (props) => {
    

    //const[votingGrid,setVotingGrid] = useState(referees);
    const{votingGrid,setVotingGrid} = props;
    console.log(votingGrid)

    return(
        <div class='mb-8'>
                <div className='flex flex-row gap-4 border-2 border-indigo-400'>
                    <div class='flex flex-col'>
                    <h1 class='border-2 border-indigo-400 text-2xl px-8'>Address</h1>
                   {votingGrid.map((referee)=>{
                       return(
                           <h1 class=' border-2 border-indigo-400 text-center hover:text-slate-500 duration-150'>
                               {referee.length>0?  referee.slice(0,4) + "....." + referee.slice(38,42) : "....."}
                           </h1>
                       )
                   })}
                        </div>
                  
                  <div>

               
                   <h1 class='border-2 border-indigo-400 text-2xl px-10' >Status</h1>
                   {votingGrid && votingGrid.map((referee)=>{
                       return(
                           <h1 class=' border-2 border-indigo-400 text-center hover:text-slate-500 duration-150 '>
                               {"N/A"}
                           </h1>
                       )
                   })}
                      </div>
                   
                </div>
            </div>
    )

}
const Recruit = (props) => {
    const{votingGrid,setVotingGrid} = props;
    const[numReferrals,setNumReferrals] = useState(0);
    const[address,setAddress] = useState('')
    const[successfulReferral,setSuccesfulReferral] = useState(undefined)
    const[errorMessage,setErrorMessage] = useState('')
    const[signature,setSignature] = useState('')
    

    // const findNumReferrals{
        // const result = votingGrid.filter(owner => owner != '')
        // setNumReferrals(7 - result.length)
    // }
    
    async function refer_a_friend(address) {
        
        if(window.ethereum){
            const provider = new ethers.providers.Web3Provider(window.ethereum,"any");
            const accounts = await provider.listAccounts();
            if(accounts.length == 0){
                setErrorMessage("Connect Wallet")
                setSuccesfulReferral(false);
                setTimeout(()=>{setSuccesfulReferral(undefined); setErrorMessage('')},2000)
            }
            if(votingGrid.filter(friend => friend != '').length>=7){
            
                setErrorMessage("All Spots Filled");
                setSuccesfulReferral(false);
                setTimeout(()=>{setSuccesfulReferral(undefined); setErrorMessage('')},2000)
                return;
            }

            if(accounts.length>0){
                const account = accounts[0]
                const isOgHelper = owners.filter(owner => owner == account);
                if(isOgHelper.length==0){
                    setErrorMessage("Not OG");
                    setSuccesfulReferral(false);
                    setTimeout(()=>{setSuccesfulReferral(undefined); setErrorMessage(''); console.log("SDASDSA")},2000)
                    return;

                }
                const signer = provider.getSigner();
                const message =  ethers.utils.solidityKeccak256(['string'],['recruit_a_friend']);    
                const arrayifyMessage = ethers.utils.arrayify(message)
                const _signature = await signer.signMessage(arrayifyMessage)

                const setFriend = await axios.post(`${process.env.REACT_APP_API_URL}/recruit/recruitFriend/${account}`,{signature:_signature,friend:address});

                setSuccesfulReferral(true);

                
                console.log(setFriend);
                setTimeout(()=>{setSuccesfulReferral(undefined)},2000);
                return;
            }

            const result = votingGrid.filter(owner => owner != '')
            setNumReferrals(7 - result.length)
            //console.log(num)
       
        if(address.length !==42){
            setErrorMessage('Invalid Address');
            setSuccesfulReferral(false);
            setTimeout(()=>{setSuccesfulReferral(undefined); setErrorMessage('')},2000)
            return;
        }

        }
        
    }
    
  return (
    <div>

        <div class='flex flex-col  items-center mt-5'>
        <h1 class='text-4xl  font-bold text- mb-4'>Recruit A Friend</h1>
         <p class='max-w-[80%] 2xl:max-w-[50%] mx-auto'>
        Holders that were part of the original snapshot have the ability to recruit 7 friends onto the whitelist for V2 passes.
        Invite your friends to get them exclusive access and earn rewards when they mint any V2 Vial.
         </p>
        </div>



        <div class='flex  justify-center  mt-12'>
        <div class='grid xl:grid-cols-2 mx-auto max-w-[60%]   space-x-'>
          
          <div class='flex flex-col gap-4 justify-center items-center'>
              <h1 class='text-2xl'>Sign Your Friends Up For Whitelist!</h1>
              <div className=''>
              <input 
              onChange={(e)=>setAddress(e.target.value)}
               class='text-center rounded-md text-black text-sm  px-4 py-1 mr-8' placeholder='address'>
               </input>
               <button  onClick={()=>refer_a_friend(address)} class=' scale-[120%] bg-indigo-500 px-4 rounded-md hover:bg-indigo-800 duration-150'>Refer</button>
               <img  src={checkmark} class={`fixed inline ml-6 h-6 ${successfulReferral? "" : "hidden"}`}></img>
               <h1 class={`${(successfulReferral != undefined) ? "mt-6 text-center xl:inline-block xl:ml-6 xl:mt-0" :"hidden"}  `}>{errorMessage}</h1>
               </div>
              <StatusTracker votingGrid={votingGrid}  setVotingGrid={setVotingGrid}/>
              <h1 class='mb-8 xl:mb-0'> Referrals Left: {numReferrals}</h1>
              
          </div>

       

          <div class='flex justify-center items-center'>
              <img class='rounded-md ml-0 xl:ml-24 h-[85%]' src={friends}></img>
          </div>



        </div>
        </div>

    </div>
  )
}

export default Recruit